import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=701eae1e&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=ts"
export * from "./SignupPage.vue?vue&type=script&lang=ts"
import style0 from "./SignupPage.vue?vue&type=style&index=0&id=701eae1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701eae1e",
  null
  
)

export default component.exports